export default "__VITE_ASSET__CyD4VZ7J__"